// src/pages/Signup.js
import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { getRoleFromToken } from '../utils/auth';

function Signup() {
  const navigate = useNavigate();
  useEffect(() => {
    // Only superadmin should access signup page
    const role = getRoleFromToken();
    if (role !== 'superadmin') {
      // redirect to login if not allowed
      navigate('/login');
    }
  }, [navigate]);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('teacher');
  const [error, setError] = useState('');

  console.log('▶ SIGNUP BASE_URI:', process.env.REACT_APP_BASE_URI);

  const handleSignup = async () => {
    try {
      setError('');
      if (!username.trim() || !password.trim()) {
        setError('Username and password cannot be empty');
        return;
      }
      await api.post('/api/signup', { username, password, role });
      navigate('/login');
    } catch (err) {
      setError(err.response?.data?.message || err.response?.data || 'Signup failed');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 5 }}>
      <Typography variant="h4" gutterBottom>Signup</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <TextField
        label="Username" fullWidth margin="normal"
        value={username} onChange={e => setUsername(e.target.value)}
      />
      <TextField
        label="Password" type="password" fullWidth margin="normal"
        value={password} onChange={e => setPassword(e.target.value)}
      />

      <FormControl fullWidth margin="normal">
        <InputLabel id="role-label">Role</InputLabel>
        <Select
          labelId="role-label" label="Role"
          value={role} onChange={e => setRole(e.target.value)}
        >
          <MenuItem value="teacher">Teacher</MenuItem>
          <MenuItem value="qa">QA</MenuItem>
        </Select>
      </FormControl>

      <Button
        variant="contained" fullWidth sx={{ mt: 2 }}
        onClick={handleSignup}
      >
        Signup
      </Button>

      <Box textAlign="center" mt={2}>
        <Button variant="text" onClick={() => navigate('/login')}>
          Already have an account? Login
        </Button>
      </Box>
    </Container>
  );
}

export default Signup;
